(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react-leaflet"), require("leaflet-ant-path"));
	else if(typeof define === 'function' && define.amd)
		define(["react-leaflet", "leaflet-ant-path"], factory);
	else if(typeof exports === 'object')
		exports["react-leaflet-ant-path"] = factory(require("react-leaflet"), require("leaflet-ant-path"));
	else
		root["react-leaflet-ant-path"] = factory(root["react-leaflet"], root["leaflet-ant-path"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__2__) {
return 